import { createFileRoute } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { unwrapPageInitialData } from "~/app/api/pageData";
import { staticWelcomePageQueryOptions } from "~/app/api/pageData/forkPageQuery";

function ForkPageRoute() {
  return null;
}

export const Route = createFileRoute("/static/welcome")({
  loader: ({ context }) => loadForkPageData(context),
  component: ForkPageRoute,
});

export async function loadForkPageData(context: { queryClient: QueryClient }) {
  const result = await context.queryClient.ensureQueryData(staticWelcomePageQueryOptions());

  return unwrapPageInitialData(result);
}
